var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagicSquareLogo = function SvgMagicSquareLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-square-logo_svg__a)",
    d: "M38.617 2.623c-2.933-2.83-7.691-2.83-10.626 0s-2.935 7.416 0 10.246l20.102 19.384 4.726-4.558c3.259-3.141 3.259-8.237 0-11.38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-square-logo_svg__b)",
    d: "m20.412 11.325 39.272 38.463-10.832 10.609L9.579 21.934z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-square-logo_svg__c)",
    d: "m20.426 38.747 20.112 18.99a7.455 7.455 0 0 1 0 10.573c-2.93 2.92-7.683 2.92-10.615 0L15.705 53.995c-3.256-3.243-3.256-7.302 0-10.545z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-square-logo_svg__d)",
    d: "M67.843 29.39a7.3 7.3 0 0 0-10.422 0c-2.877 2.918-2.877 7.648 0 10.567l5.21 5.285 5.212-5.285c2.876-2.919 2.876-7.649 0-10.568Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-square-logo_svg__e)",
    d: "m7.369 25.758 5.21 5.283c2.877 2.92 2.877 7.65 0 10.569a7.295 7.295 0 0 1-10.421 0c-2.877-2.92-2.877-7.65 0-10.569z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-square-logo_svg__a",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-square-logo_svg__b",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-square-logo_svg__c",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-square-logo_svg__d",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-square-logo_svg__e",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })))));
};
export { SvgMagicSquareLogo as ReactComponent };